<template>
  <div class="regist" v-loading.fullscreen.lock="loading">
    <el-dialog title="注册" :visible.sync="zcFormVisible" custom-class="dialog-t zc" width="677px" :before-close="clearZc">
      <div class="form">
        <div class="input_text">
          <span class="label"><sup>*</sup>账号</span>
          <input type="text" class="text"  v-model="zc_form.username">
        </div>
        <div class="input_text">
          <span class="label"><sup>*</sup>密码</span>
          <input type="password" class="text" v-model="zc_form.password" minlength="6" maxlength="12">
        </div>
        <div class="input_text">
          <span class="label"><sup>*</sup>确认密码</span>
          <input type="password" class="text" v-model="zc_form.confirm_password" minlength="6" maxlength="12">
        </div>
        <div class="input_text">
          <span class="label"><sup>*</sup>验证码</span>
          <div class="text">
            <input @focus="showCaptchaEvent" type="text" v-model="zc_form.captcha" ref="captcha_input">
            <img ref="captcha_img" @click="changeImg($event)" v-show="showCaptcha" width="105" height="32">
          </div>
        </div>
        <div class="zc_p">
          <input type="checkbox" checked ref="checkbox" class="checkbox">我已届满合法博彩年龄，且同意各项开户条约。
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="regist">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { userResource } from '@/resource/resource'
  import { mapState, mapMutations } from 'vuex'
  import { addCookie } from '@/common/js/cookies'
  import { saveToLocal } from '@/common/js/store'

  const ERR_OK = 0

  export default {
    name: 'regist',
    data () {
      return {
        zcFormVisible: false,
        zc_form: {
          username: '',
          password: '',
          confirm_password: '',
          captcha: ''
        },
        // captcha: '',
        showCaptcha: false, // 是否显示注册验证码
        disabled: false,
        loading: false
      }
    },
    computed: {
      ...mapState(['config_info'])
    },
    created () {
    },
    methods: {
      showRegist(state) {
        this.zcFormVisible = state
      },
      clearZc (done) {
        done()
        this.zc_form = {
          username: '',
          password: '',
          confirm_password: '',
          captcha: ''
        }
      },
      // 用户注册
      regist () {
        if (!this.zc_form.username) {
          this.$alert('用户名不能为空', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        } else if (!this.zc_form.password) {
          this.$alert('密码不能为空', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        } else if (!this.zc_form.confirm_password) {
          this.$alert('确认密码不能为空', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
         } else if (!this.zc_form.captcha) {
          this.$alert('验证码不能为空', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        } else if (!this.$refs.checkbox.checked) {
          this.$alert('请勾选用户条约', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
        this.loading = true
        // userResource.captcha({key: 'abc'}).then(res => {
        //   res = res.body
        //   if (res.errcode === ERR_OK) {
        //     this.zc_form.captcha = 'abc'
        //   }
        // })
        userResource.register(this.zc_form).then(resp => {
          resp = resp.body
          this.loading = false
          if (resp.errcode === ERR_OK) {
            this.zcFormVisible = false
            this.$alert('注册成功', '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {
                saveToLocal('token', resp.data['access-token'])
                addCookie('isLogined', true, 120)
                this.getUserInfo()
                // this.$router.push('/')
                this.$emit('logined')
              }
            })
          } else {
            this.$nextTick(() => {
              this.$refs.captcha_img.src = this.cap + Date.parse(new Date()) / 1000
              this.$refs.captcha_input.focus()
            })
          }
        })
      },
      // 显示验证码图片(用于注册)
      showCaptchaEvent () {
        if (!this.showCaptcha) {
          this.$nextTick(() => {
            this.$refs.captcha_img.src = this.cap + Date.parse(new Date()) / 1000
          })
        }
        this.showCaptcha = true
      },
      // 更换验证码图片
      changeImg (e) {
        e.target.src = this.cap + Date.parse(new Date()) / 1000
      },
      getCheck () {
        this.dialogProtocol = false
        this.$refs.checkbox.checked = true
      },
      getUserInfo() {
        this.loading = true
        userResource.info().then(res => {
          res = res.body
          this.loading = false
          if (res.errcode === ERR_OK) {
            this.RECORD_USERINFO(res.data)
          }
        })
      },
      // 更新vuex状态信息
      ...mapMutations([
        'RECORD_USERINFO'
      ])
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
</style>



// WEBPACK FOOTER //
// regist.vue?50899718